import React from 'react'
import { Link } from 'react-router-dom';
import Butao from '../../Components/Butao';
import MenuLink from '../../Components/MenuLink';
import Api from "../../Api";

export default ({InfIdConta, InfIdUse,  DadCont, sair , Dados, CriarDados, ApagarDados}) => {
  const Desbloquear = () => {
    Api.DesbloqueioContaServ();
  }

  return (
  <div>
  <aside className="main-sidebar sidebar-dark-primary elevation-4">
    {/* Brand Logo */}
    <a href="#" className="brand-link" >
      <img src="assets/GBlogomarca.png" alt="LogoEmpresa"  style={{opacity: '1', width: 150, marginRight: 20, marginLeft:20 }} />
    
    </a>
    {/* Sidebar */}
    <div className="sidebar">
      {/* Sidebar user panel (optional) */}
      <div className="user-panel mt-3 pb-3 mb-3 d-flex">
        <div className="image">
          
        </div>
        <div className="info">
          {InfIdUse &&
         <a href="#" className="d-block">{InfIdUse.Nome}</a>
          }
          
        </div>
      </div>
      {/* Sidebar Menu */}
      <nav className="mt-2">
        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
       
         {DadCont === "Emp"  &&
         <>
         <MenuLink 
         Linkto={"/Categorias"}
         Icon={"fas fa-bezier-curve"}
         Titulo={"Categorias"}
         Notificacao={false}
         NotiEstilo={"right badge badge-danger"}
         ValorNoti={"New"}
         />
          <MenuLink 
         Linkto={"/Exercicios"}
         Icon={"fas fa-dumbbell"}
         Titulo={"Exercícios"}
         Notificacao={false}
         NotiEstilo={"right badge badge-danger"}
         ValorNoti={"New"}
         />
         <MenuLink 
         Linkto={"/Clientes"}
         Icon={"far fa-address-card"}
         Titulo={"Clientes"}
         Notificacao={false}
         NotiEstilo={"right badge badge-danger"}
         ValorNoti={"New"}
         />
       
         <MenuLink 
         Linkto={"/Representantes"}
         Icon={"fas fa-briefcase"}
         Titulo={"Representantes"}
         Notificacao={false}
         NotiEstilo={"right badge badge-danger"}
         ValorNoti={"New"}
         />
          <MenuLink 
         Linkto={"/Recebimentos"}
         Icon={"fas fa-cash-register"}
         Titulo={"Recebimentos"}
         Notificacao={false}
         NotiEstilo={"right badge badge-danger"}
         ValorNoti={"New"}
         />
          <MenuLink 
         Linkto={"/Pagamentos"}
         Icon={"fas fa-donate"}
         Titulo={"Pagamentos"}
         Notificacao={false}
         NotiEstilo={"right badge badge-danger"}
         ValorNoti={"New"}
         />
          {Dados &&
            <>
            {Dados.Alunos &&
            <>
            {Dados.Alunos.Ver &&
            <>
             <MenuLink 
            Linkto={"/Alunos"}
            Icon={"far fa-address-card"}
            Titulo={"Alunos"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
             </>
            }
            </>
            }
        {Dados &&
            <>
            {Dados.Treinos.Ver &&
            <>
             <MenuLink 
              Linkto={"/Treinos"}
              Icon={"fas fa-edit"}
              Titulo={"Treinos"}
              Notificacao={false}
              NotiEstilo={"right badge badge-danger"}
              ValorNoti={"New"}
            />
            </>
            }
            </>
            }
            {Dados &&
            <>
            {Dados.Recebimentos.Ver &&
            <>
             <MenuLink 
            Linkto={"/RecebimentosAlunos"}
            Icon={"fas fa-cash-register"}
            Titulo={"Receb. Alunos"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            }
            {Dados &&
            <>
            {Dados.Medidas.Ver &&
            <>
            <MenuLink 
            Linkto={"/MedidasAlunos"}
            Icon={"fas fa-clipboard"}
            Titulo={"Medidas"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            }
             {Dados &&
            <>
            {Dados.Histórico.Ver &&
            <>
            <MenuLink 
            Linkto={"/HistoricoAlunos"}
            Icon={"fas fa-book"}
            Titulo={"Histórico"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            }
            {Dados &&
            <>
            {Dados.Funcionários.Ver &&
            <>
             <MenuLink 
            Linkto={"/Funcionarios"}
            Icon={"far fa-address-book"}
            Titulo={"Funcionários"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
            {Dados &&
            <>
            {Dados.Permissões.Ver &&
            <>
             <MenuLink 
            Linkto={"/Permissoes"}
            Icon={"fas fa-columns"}
            Titulo={"Permissões"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
            {Dados &&
            <>
            {Dados.Acões.Ver &&
            <>
            <MenuLink 
            Linkto={"/Acoes"}
            Icon={"far fa-hand-pointer"}
            Titulo={"Acões"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            }  
         </>
         
          }
           {InfIdConta && Object.keys(InfIdConta).length > 0 &&
                        <>
          {InfIdConta.Ativo &&
          <>
          {(DadCont === "Cliente" || DadCont === "Fun")  &&
          <>
           <MenuLink 
            Linkto={"/"}
            Icon={"fas fa-home"}
            Titulo={"Início"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            {Dados &&
            <>
             {Dados.Alunos &&
            <>
            {Dados.Alunos.Ver &&
            <>
             <MenuLink 
            Linkto={"/Alunos"}
            Icon={"far fa-address-card"}
            Titulo={"Alunos"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            }
            </>
            }
             {Dados &&
            <>
            {Dados.Categorias.Ver &&
            <>
             <MenuLink 
              Linkto={"/Categorias"}
              Icon={"fas fa-bezier-curve"}
              Titulo={"Categorias"}
              Notificacao={false}
              NotiEstilo={"right badge badge-danger"}
              ValorNoti={"New"}
              />
            </>
            }
            </>
            }
          {Dados &&
            <>
            {Dados.Exercícios.Ver &&
            <>
             <MenuLink 
              Linkto={"/Exercicios"}
              Icon={"fas fa-dumbbell"}
              Titulo={"Exercícios"}
              Notificacao={false}
              NotiEstilo={"right badge badge-danger"}
              ValorNoti={"New"}
              />
            </>
            }
            </>
            }
             {Dados &&
            <>
            {Dados.Treinos.Ver &&
            <>
             <MenuLink 
              Linkto={"/Treinos"}
              Icon={"fas fa-edit"}
              Titulo={"Treinos"}
              Notificacao={false}
              NotiEstilo={"right badge badge-danger"}
              ValorNoti={"New"}
            />
            </>
            }
            </>
            }
                
            {Dados &&
            <>
            {Dados.Recebimentos.Ver &&
            <>
             <MenuLink 
            Linkto={"/RecebimentosAlunos"}
            Icon={"fas fa-cash-register"}
            Titulo={"Recebimentos"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
           {Dados &&
            <>
            {Dados.Pagamentos.Ver &&
            <>
            <MenuLink 
            Linkto={"/PagamentosEmpresa"}
            Icon={"fas fa-donate"}
            Titulo={"Pagamentos"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
            {Dados &&
            <>
            {Dados.Medidas.Ver &&
            <>
            <MenuLink 
            Linkto={"/MedidasAlunos"}
            Icon={"fas fa-clipboard"}
            Titulo={"Medidas"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
             {Dados &&
            <>
            {Dados.Histórico.Ver &&
            <>
            <MenuLink 
            Linkto={"/HistoricoAlunos"}
            Icon={"fas fa-book"}
            Titulo={"Histórico"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
             {Dados &&
            <>
            {Dados.Funcionários.Ver &&
            <>
             <MenuLink 
            Linkto={"/Funcionarios"}
            Icon={"far fa-address-book"}
            Titulo={"Funcionários"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
            {Dados &&
            <>
            {Dados.Permissões.Ver &&
            <>
             <MenuLink 
            Linkto={"/Permissoes"}
            Icon={"fas fa-columns"}
            Titulo={"Permissões"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
            
             {Dados &&
            <>
            {Dados.Avisos.Ver &&
            <>
            <MenuLink 
            Linkto={"/Avisos"}
            Icon={"far fa-envelope-open"}
            Titulo={"Avisos"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
            {Dados &&
            <>
            {Dados.Acões.Ver &&
            <>
            <MenuLink 
            Linkto={"/Acoes"}
            Icon={"far fa-hand-pointer"}
            Titulo={"Acões"}
            Notificacao={false}
            NotiEstilo={"right badge badge-danger"}
            ValorNoti={"New"}
            />
            </>
            }
            </>
            } 
          </>
          }
         </>
          }
           </>
          }    
          <li className="nav-item">
            <div className="input_cadatro">
                        <Butao 
                          onClick={sair}
                          text={"Sair"}
                        />
                </div>
          </li> 
          {/* <li className="nav-item">
            <div className="input_cadatro">
                        <Butao 
                          onClick={CriarDados}
                          text={"CriarDados"}
                        />
                </div>
          </li> 
          <li className="nav-item">
            <div className="input_cadatro">
                        <Butao 
                          onClick={ApagarDados}
                          text={"ApagarDados"}
                        />
                </div>
          </li> 
          <li className="nav-item">
            <div className="input_cadatro">
                        <Butao 
                          onClick={Desbloquear}
                          text={"Desbloquear"}
                        />
                </div>
          </li>  */}

        </ul>
      </nav>
    </div>
  </aside>
</div>

     
    );
}
